/**
 * ExchangeRateChip — 헤더용 환율 위젯 (현재 환율 + 전일 대비 등락폭)
 * 클릭 시 ExchangeRateModal(90일 추이 차트) 오픈.
 * 쿼리키 ["brief","fx"]는 DashboardPage와 공유 — 캐시 히트 시 API 0회.
 */
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { theme } from "antd";
import { useThemeStore } from "src/stores/ThemeStore";
import { briefApi } from "src/api/brief";
import ExchangeRateModal from "./ExchangeRateModal";

const ExchangeRateChip = () => {
  const { token } = theme.useToken();
  const isDark = useThemeStore((s) => s.isDarkMode);
  const [open, setOpen] = useState(false);

  const fxQ = useQuery({
    queryKey: ["brief", "fx"],
    queryFn: () => briefApi.getExchangeRate(),
    staleTime: 10 * 60_000,
    refetchInterval: 5 * 60_000, // 헤더 상시 마운트 — 주가와 동일하게 5분 간격 자동 갱신
  });

  const fx = fxQ.data;
  const up = (fx?.change ?? 0) >= 0;

  return (
    <>
      <div
        onClick={() => fx && setOpen(true)}
        title={fx ? "환율 흐름 보기" : undefined}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          cursor: fx ? "pointer" : "default",
          padding: "3px 10px",
          borderRadius: 8,
          background: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.03)",
          userSelect: "none",
          whiteSpace: "nowrap",
        }}
      >
        {fxQ.isLoading ? (
          <span style={{ fontSize: 12, color: token.colorTextSecondary }}>환율…</span>
        ) : fx ? (
          <>
            <span style={{ fontSize: 12, fontWeight: 600, color: token.colorText }}>
              $ {fx.current_rate.toFixed(1)}
            </span>
            <span className={up ? "fred" : "fblue"} style={{ fontSize: 11, fontWeight: 600 }}>
              {up ? "▲" : "▼"} {Math.abs(fx.change).toFixed(1)} ({up ? "+" : "-"}
              {Math.abs(fx.change_percent).toFixed(2)}%)
            </span>
          </>
        ) : null}
      </div>
      <ExchangeRateModal open={open} onClose={() => setOpen(false)} currentRate={fx?.current_rate} />
    </>
  );
};

export default ExchangeRateChip;
